import type { CourseTreeNode } from "@/types/generated";
import type { AudioStoryboard } from "@/types/storyboard";
import AudioElement from "@/components/storyboard/audio/AudioElement";
import { StoryboardFallback } from "@/components/storyboard/StoryboardFallback";

interface Props {
  data: AudioStoryboard;
  contentElement: CourseTreeNode;
}

// External audio is produced as a Vimeo/YouTube video with a still image;
// participants get audio-player UX (thumbnail + play/seek controls).
export const StoryboardAudioRenderer = ({ data, contentElement }: Props) => {
  switch (data.subType) {
    case "EXTERNAL_AUDIO":
      return <AudioElement audio={data.audio} />;
    default:
      return <StoryboardFallback title={contentElement.title} />;
  }
};
